/* MessageDialogRenderer.js */

"use strict";
const DOMPurify = require("dompurify");
const _ = require("lodash");
const ButtonControl = require("@gluenetworks/steve_ui_core").Control.Action.Button;

class MessageDialogRenderer {
    constructor(model) {
        this._model = model;
        this._rootElem = document.createElement("message-dialog-gl");
        this._rootElem.component = this._model;

        this._modalMask = document.createElement("modal-mask-gl");
        this._messageElem = document.createElement("h3");

        this._buttonGroupContainer = document.createElement("button-group-container");
        this._buttonGroupContainer.classList.add("button-group");

        this._confirmButton = new ButtonControl({id: "confirm", value: "confirm"});
        this._confirmButton.renderer.rootElement.classList.add("confirm-button");

        this._registerListeners();
    }
    /********************************************/
    /* START PRIVATE COMPONENT RENDERER METHODS */
    /********************************************/
    _shutdown() {
        return this._confirmButton.shutdown().then(() => {
            this._unregisterListeners();
            this._messageElem.remove();
            this._messageElem = null;
            this._modalMask = undefined;
            this._confirmButton = null;
            this._model = undefined;
            this._rootElem.remove();
            this._rootElem = undefined;
            return Promise.resolve();
        });
    }
    _registerListeners() {
        this._model.on("Shutdown", (this._onShutdown = this._onShutdown.bind(this)));
    }
    _unregisterListeners() {
        this._model.removeListener("Shutdown", this._onShutdown);
        this._confirmButton.removeAllListeners("UserClick");
    }
    _unregisterConfirmationListeners() {
        this._confirmButton.removeAllListeners("UserClick");
    }
    _showDialog() {
        this._rootElem.classList.add("shown");
    }
    _hideDialog() {
        this._rootElem.classList.remove("shown");
    }
    /*******************************************/
    /* END PRIVATE COMPONENT RENDERER METHODS  */
    /* START PUBLIC COMPONENT RENDERER METHODS */
    /*******************************************/
    /**
     * Stateless method to completely rebuild this component from the _rootElem down.
     * @returns {Promise} An ES6 promise that lets the caller know when the component has finished rendering. If a non
     * Promise is returned the caller will assume the Renderer has completed rendering.
     */
    render() {
        this._confirmButton.label = this.model.options.confirmButtonName;
        if (_.get(this.model, "options.enableHtml", false)) {
            this._messageElem.innerHTML = DOMPurify.sanitize(this.model.options.message);
        } else {
            this._messageElem.innerText = this.model.options.message;
        }
        if (!this._rootElem.hasChildNodes()) {
            this._rootElem.appendChild(this._modalMask);
            this._modalMask.appendChild(this._messageElem);
            this._modalMask.appendChild(this._buttonGroupContainer);
            this._buttonGroupContainer.appendChild(this._confirmButton.renderer.getRootElement());
        }
        if (this.model.showDialog) {
            this._showDialog();
            return new Promise((resolve) => {
                this._confirmButton.on("UserClick", () => {
                    this._unregisterConfirmationListeners();
                    resolve();
                });
            });
        } else {
            this._hideDialog();
            return Promise.resolve();
        }
    }
    get rootElement() {
        return this.getRootElement();
    }
    getRootElement() {
        return this._rootElem;
    }
    get model() {
        return this.getModel();
    }
    getModel() {
        return this._model;
    }
    /*******************************************/
    /* END COMPONENT RENDERER METHODS */
    /* START PRIVATE RENDER METHODS */
    /*******************************************/
    //TODO Private Render Methods here
    /*******************************************/
    /* END PRIVATE RENDER METHODS */
    /* START HANDLER METHODS */
    /*******************************************/
    _onShutdown() {
        this._shutdown();
    }
    /*******************************************/
    /* END HANDLER METHODS */
    /* START PRIVATE API METHODS */
    /*******************************************/
    //TODO - Nobody should be using methods on a Renderer directly so make all these methods private
    /*******************************************/
    /*  END PRIVATE API METHODS */
    /*******************************************/
}

module.exports = MessageDialogRenderer;
